var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99951 10L7.99951 8M7.99951 8L9.99951 6M7.99951 8L5.99951 6M7.99951 8L9.99951 10M7.99941 14.0999C4.63048 14.0999 1.89941 11.3688 1.89941 7.9999C1.89941 4.63097 4.63048 1.8999 7.99941 1.8999C11.3684 1.8999 14.0994 4.63097 14.0994 7.9999C14.0994 11.3688 11.3684 14.0999 7.99941 14.0999Z",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.1231c5f12d8149b003ed2f87a22a22e5.svg";
export { ForwardRef as ReactComponent };